import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocaleProvider } from '@op/opds.opux';
import PriceListContextProvider from './context/PriceListContext';
import ErrorWrapper from './utils/ErrorWrapper';

const locale = (document.documentElement.getAttribute('lang') || 'fi')
    .substring(0, 2)
    .toLowerCase();

if (locale !== "en") {
  ReactDOM.render(
    <React.StrictMode>
      <LocaleProvider locale={locale}>
        <PriceListContextProvider>
          <ErrorWrapper>
           <App />
          </ErrorWrapper>
        </PriceListContextProvider>
      </LocaleProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
